import type { ElementType } from './form.types';

const VALUE_FIELD_TYPES = [
  'TEXT_INPUT',
  'PARAGRAPH',
  'NUMBER_INPUT',
  'URL_INPUT',
  'EMAIL_INPUT',
  'REGISTER_NUMBER_INPUT',
  'DROPDOWN',
  'RADIO_GROUP',
] as const satisfies readonly ElementType[];

export const ARCHIVING_DATE_ROUTE_TYPES = ['DATE_INPUT'] as const satisfies readonly ElementType[];

export const ARCHIVING_VALUE_ROUTE_TYPES = [
  'FILL_TITLE',
  ...VALUE_FIELD_TYPES,
] as const satisfies readonly ElementType[];

export const INDEXING_FIELD_TYPES = [
  ...VALUE_FIELD_TYPES,
  'DATE_INPUT',
  'CHECKBOX',
] as const satisfies readonly ElementType[];
